import { render, staticRenderFns } from "./AppChatRoomList.vue?vue&type=template&id=c52e796c&"
import script from "./AppChatRoomList.vue?vue&type=script&lang=ts&"
export * from "./AppChatRoomList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports